import { supabase } from '@/lib/supabase';
import { SupportRequestFormData } from '@/types/support-request.types';

export const supportRequestService = {
  async submitSupportRequest(data: SupportRequestFormData) {
    try {
      // Insert into database
      const { data: insertedData, error: dbError } = await supabase
        .from('support_requests')
        .insert({
          full_name: data.full_name,
          company: data.company || null,
          phone: data.phone,
          email: data.email,
          issue_description: data.issue_description,
          status: 'pending',
        })
        .select()
        .single();

      if (dbError) {
        console.error('Database error:', dbError);
        throw new Error('Failed to save support request to database');
      }

      // Send email via edge function
      const emailResponse = await fetch(
        `${process.env.NEXT_PUBLIC_SUPABASE_URL}/functions/v1/send-support-request-email`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY}`
          },
          body: JSON.stringify({
            full_name: data.full_name,
            company: data.company,
            phone: data.phone,
            email: data.email,
            issue_description: data.issue_description,
          })
        }
      );

      const emailResult = await emailResponse.json();

      if (!emailResponse.ok) {
        console.error('Email sending failed:', emailResult);
        // Don't throw error - request was saved to databaseconsole.warn('Support request saved but email notification failed');
      }

      return {
        success: true,
        data: insertedData,
        emailSent: emailResponse.ok
      };
    } catch (error) {
      console.error('Support request service error:', error);
      throw error;
    }
  }
};